// Mock data pro KONTAKT Fest vendor aplikace

export const festivalInfo = {
  name: "KONTAKT Fest 2026",
  date: "13.–14. června 2026",
  location: "Amfiteátr na Horečkách, Frenštát pod Radhoštěm",
  region: "Beskydy",
  type: "Dvoudenní hudebně-lifestyle festival",
  expectedVisitors: "8000+",
  year2025Visitors: 4000,
};

export const programSchedule = {
  saturday: {
    day: "Sobota 13. 6. 2026",
    time: "14:00–23:00",
    description: "Hlavní koncertní den s nejsilnějším večerním prodejním peakem",
  },
  sunday: {
    day: "Neděle 14. 6. 2026",
    time: "10:00–19:00",
    description: "Rodinný den a dětský program",
    specialEvent: "Závěrečný koncert Čechomor",
  },
};

export const whyJoinReasons = [
  {
    title: "Vysoká návštěvnost",
    description: "Ročník 2025 navštívilo 4000 osob, festival byl kompletně vyprodán. Očekáváme 8000+ návštěvníků.",
    icon: "Users",
  },
  {
    title: "Dlouhá doba pobytu",
    description: "Návštěvníci zůstávají v areálu celý den. V hlavních časech programu se u gastro zóny tvořily výrazné fronty.",
    icon: "Clock",
  },
  {
    title: "Dvoudenní akce",
    description: "Sobotní koncertní den + nedělní rodinný program = dva plnohodnotné prodejní dny s vysokou návratností investice.",
    icon: "Calendar",
  },
  {
    title: "Limitovaný počet stánků",
    description: "Vědomě omezujeme počet prodejců, aby každý měl dostatečný obrat a nedošlo k přesycení nabídky.",
    icon: "ShieldCheck",
  },
  {
    title: "Unikátní lokalita",
    description: "Horský amfiteátr v Beskydech přirozeně koncentruje návštěvníky uvnitř areálu a minimalizuje odchody mimo festival.",
    icon: "Mountain",
  },
  {
    title: "Kvalitní publikum",
    description: "Rodiny s dětmi, páry 25–45 let s nadprůměrnou dobou pobytu a vysokou útratou za gastro.",
    icon: "Heart",
  },
];

export const vendorCategories = {
  priority: {
    title: "PRIORITA: Food Trucky",
    description: "Hlavní prioritou jsou silné a kapacitní food trucky s rychlou obsluhou a zkušenostmi z festivalů.",
    requirements: [
      "Zkušenosti z festivalů",
      "Kapacitní obsluha",
      "Rychlé odbavení zákazníků",
      "Kvalitní street food koncepty",
    ],
    reason: "V minulém ročníku poptávka po gastro výrazně převyšovala kapacity a vznikaly dlouhé fronty.",
  },
  additional: {
    title: "Doplňkový prodej",
    description: "Omezený počet míst pro doplňkový sortiment",
    categories: [
      "Sladké speciality a dezerty",
      "Zmrzlina",
      "Lokální produkty",
      "Handmade výrobky",
      "Design a lifestyle produkty",
    ],
  },
};

export const importantRules = [
  {
    title: "Exkluzivita nápojů",
    description: "Alkoholické i nealkoholické nápoje zajišťuje výhradně pořadatel. Prodej piva, limonád a alkoholu není externím prodejcům povolen.",
    note: "Výjimky (káva, specifické nápojové koncepty) pouze po domluvě s pořadatelem.",
    icon: "XCircle",
  },
  {
    title: "Platební systém NFC TRON",
    description: "Platba hotovostí i kartou přes terminály NFC TRON. Každý prodejce obdrží terminál. Veškeré příjmy musí být zadávány do terminálu.",
    warning: "Sankce 5000 Kč za každé porušení!",
    icon: "CreditCard",
  },
];

export const formFields = {
  basicInfo: [
    { name: "email", label: "Email", type: "email", required: true },
    { name: "name", label: "Jméno a příjmení", type: "text", required: true },
    { name: "phone", label: "Telefon", type: "tel", required: true },
    { name: "vendorName", label: "Název prodejce", type: "text", required: true },
  ],
  businessInfo: [
    { 
      name: "vatPayer", 
      label: "Plátce DPH", 
      type: "radio", 
      options: ["Ano", "Ne"],
      required: true 
    },
    { 
      name: "invoiceDetails", 
      label: "Fakturační údaje (název subjektu, IČ, DIČ, fakturační adresa)", 
      type: "textarea", 
      required: true 
    },
  ],
  vendorDetails: [
    { name: "website", label: "WWW / FB stránky prodejce", type: "text", required: true },
    { 
      name: "description", 
      label: "Napište o sobě pár vět (použijeme k propagaci na soc. sítích)", 
      type: "textarea", 
      required: true 
    },
    { 
      name: "menu", 
      label: "Předpokládané menu (ceny nemusíte uvádět)", 
      type: "textarea", 
      required: true 
    },
    { name: "stallSize", label: "Rozměr stánku (např. 3x3m)", type: "text", required: true },
    { 
      name: "electricConnection", 
      label: "Jakou elektrickou přípojku potřebujete?", 
      type: "radio",
      options: [
        "230V max 3,5 kW",
        "16A/380V (3f) - 3,5kW až 6kW",
        "32A/380V (3f) - 6kW až 12 kW",
        "Jiné (upřesním v poznámce)"
      ],
      required: true 
    },
  ],
  additional: [
    { 
      name: "photos", 
      label: "Pošlete reprezentativní fotografie (max 5ks) na email", 
      type: "checkbox",
      options: ["Ano, pošlu fotografie k propagaci"],
      required: false 
    },
    { 
      name: "notes", 
      label: "Poznámky", 
      type: "textarea", 
      required: false 
    },
  ],
};

export const pricingConditions = {
  foodTrucks: {
    title: "FOOD TRUCKY/STÁNKY s jídlem",
    size: "do 6x3m",
    category: "hlavní prodejci jídla",
    price: "15.000 Kč/den",
  },
  additional: {
    title: "SLADKÉ, POCHUTINY, VÝROBKY, HRAČKY",
    size: "max. 6x3m",
    category: "ostatní prodejci",
    price: "7.000 Kč/den",
  },
  electricity: {
    title: "ENERGIE - příkon (MAX 12 KW)",
    options: [
      { range: "DO 3KW", price: "1.750 Kč" },
      { range: "3KW až 6KW", price: "3.300 Kč" },
      { range: "nad 6KW", price: "4.500 Kč" },
    ],
    note: "(celá akce)",
  },
  deposit: {
    title: "VRATNÁ KAUCE",
    price: "5.000 Kč",
  },
  note: "Ceny jsou uvedeny bez DPH",
  specialNote: "Prodejci jen na SOBOTU k open stage: Hledáme prodejce rychlovýdejního sortimentu typu nudle, gyros apod. V neděli open stage v provozu nebude. Podmínky stejné jako u dvoudenního prodeje.",
};

export const lineupImages = {
  saturday: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/9xgv7uij_sobota%20kontakt.jpg",
  sunday: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/q8h8egp8_nede%CC%8Cle%20kontakt.jpg",
};

export const heroImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/cach2n83_kontaktfest0690-Pano.jpg";

// Mock response po odeslání formuláře
export const submitFormMock = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock: Formulář odeslán", formData);
      resolve({
        success: true,
        message: "Přihláška byla úspěšně odeslána!",
        registrationId: `KONTAKT-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
      });
    }, 1000);
  });
};
